import get from 'lodash/get'

/**
 * Rollout gate for handover label printing (CROCS-972/974).
 *
 * Driven by the per-subco database flag subco.label_printing_enabled,
 * exposed on the SDK Subco instance as labelPrintingEnabled. Enable a
 * region with:
 *   UPDATE "subco"."subco" SET label_printing_enabled = true WHERE tag = '<TAG>';
 */
export const isPrinterFeatureEnabled = (subco?: unknown): boolean =>
  !!get(subco, 'labelPrintingEnabled')
